module.exports = __webpack_public_path__ + "download_new.d26c8316.png";